<template>
    <div class="coupon-nav">
        <div
            ref="coupon"
            class="coupon-item"
            @click="handleRedirect"
        >
            <span class="coupon-icon"></span>
            <span class="coupon-count">{{ couponInfo.availablePoints }}</span>
        </div>
        <veui-popover
            theme="ai"
            :open.sync="showPopover"
            target="coupon"
            position="bottom"
            overlay-class="coupon-popover"
            :overlay-style="{
                width: isOnlyCoupon ? '240px' : '300px' ,
            }"
        >
            <div class="coupon-popover-container">
                <div class="coupon-popover-header">
                    <div class="coupon-popover-header-img"></div>
                    <div class="coupon-popover-header-content">
                        <div class="coupon-popover-title">我的权益</div>
                        <div
                            class="coupon-popover-pay-btn"
                            @click="handleClickCouponPay"
                        >
                            立即充值
                        </div>
                    </div>
                </div>
                <div
                    class="coupon-popover-body"
                    :style="{height: isOnlyCoupon ? '90px' : '100%'}"
                >
                    <div
                        :class="
                            isOnlyCoupon ? 'coupon-popover-count' : 'coupon-popover-count-uc-baidu'
                        "
                    >
                        <div class="coupon-count-desc">点券余额</div>
                        <div class="coupon-count">{{ couponInfo.availablePoints }}</div>
                    </div>
                    <div v-if="!isOnlyCoupon" class="coupon-popover-property">
                        <div class="coupon-popover-line"></div>
                        <div
                            v-for="(value,key) in availableCounts"
                            :key="key"
                            class="property-item"
                        >
                            <div>{{ value.text }}</div>
                            <div class="property-item-right">
                                <span class="property-item-count">{{ value.count }}</span>
                                <span>/次</span></div>
                        </div>
                    </div>

                </div>
            </div>
        </veui-popover>
        <contact-dialog v-if="isUC" :open.sync="showContactDialog"/>
        <coupon-pay-dialog v-else :open.sync="showPayDialog"/>

    </div>
</template>

<script>
import {Popover} from 'veui';
import CouponPayDialog from './CouponPayDialog';
import ContactDialog from './ContactDialog.vue';
import couponMixin from '@/mixins/couponMixin';
import {
    assetsTypeMapping,
    DIGITAL_HUMAN_BASICS_CARD, DIGITAL_HUMAN_EXCELLENT_CARD,
    DIGITAL_HUMAN_VOICE_BASICS_CARD, DIGITAL_HUMAN_VOICE_EXCELLENT_CARD
} from '@/common/couponConfig';
export default {
    name: 'NavCoupon',
    components: {
        'veui-popover': Popover,
        'coupon-pay-dialog': CouponPayDialog,
        'contact-dialog': ContactDialog
    },
    inject: ['model', '$toast', 'alsLog'],
    mixins: [couponMixin],
    data() {
        return {
            showPayDialog: false,
            showPopover: false,
            showContactDialog: false
        };
    },
    watch: {
        showPopover(val) {
            if (val) {
                this.alsLog({
                    f1: 'couponPopover',
                    f2: 'show',
                    f5: this.$route.name
                });
            }
        }
    },
    methods: {
        handleClickCouponPay() {
            this.alsLog({
                f1: 'couponPayEnter',
                f2: 'click',
                f11: 'couponPopover'
            });
            if (this.isUC) {
                this.showContactDialog = true;
            }
            else {
                this.showPayDialog = true;
            }
        },
        handleRedirect() {
            this.alsLog({
                f1: 'couponEnter',
                f2: 'click',
                f11: 'couponCount'
            });
            this.$router.push({
                name: 'couponManage'
            });
        }
    },
    computed: {
        isUC() {
            return this.$store.state.app.userInfo.isUC;
        },
        couponInfo() {
            return this.$store.state.app.couponInfo || {};
        },
        availableCounts() {
            const keys = [
                DIGITAL_HUMAN_BASICS_CARD,
                DIGITAL_HUMAN_EXCELLENT_CARD,
                DIGITAL_HUMAN_VOICE_BASICS_CARD,
                DIGITAL_HUMAN_VOICE_EXCELLENT_CARD
            ];
            const res = {};
            keys.forEach(key => {
                const v = assetsTypeMapping[key];
                if (this.couponInfo[v.value]) {
                    res[key] = {
                        text: v.desc,
                        count: this.couponInfo[v.value]
                    };
                }
            });
            return res;
        },
        isOnlyCoupon() {
            // 如果仅有点券就居中显示点券，有其他次数点券就显示为一列，
            return Object.keys(this.availableCounts).length === 0;
        }
    }
};
</script>

<style scoped lang="less">
.coupon-nav {
    .coupon-item {
        display: inline-flex;
        padding: 4px 8px 4px 4px;
        justify-content: center;
        align-items: center;
        gap: 4px;
        border-radius: 24px;
        border: 1px solid #FCE7CF;
        background: var(--Yellow-2, #FFF4DD);
        line-height: 20px;
        cursor: pointer;
        .coupon-icon {
            display: inline-block;
            width: 20px;
            height: 20px;
            background: url(https://qiaojiang.bj.bcebos.com/fe/iconGoldenDiamond_72x72.png) no-repeat;
            background-size: 100%;
            vertical-align: top;
            margin-right: 4px;
        }
        .coupon-count {
            color: var(----active-W8, var(--Yellow-8, #D88F00));
            text-align: center;
            font-family: "Baidu Number Plus", "Baidu Number";
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 142.857% */
        }
    }
}
.coupon-popover {

    /deep/ .veui-ai-tooltip {
        border-radius: 12px;
        border: none;
        overflow: hidden;
        &-content {
            margin: 0;
        }
    }
    /deep/ .veui-ai-popover-content {
        overflow: hidden;
    }
    /deep/ .veui-ai-tooltip-arrow {
        display: none;
    }
    &-container {
        position: relative;
    }
    &-header {
        position: relative;
        height: 70px;
        background-image: url('../../assets/couponPopoverBg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        overflow: hidden;
        &-content {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 16px 26px 16px;

        }
        &-img {
            background-image: url('../../assets/couponPopoverDiamond.png');
            position: absolute;
            top: 0;
            right: -30px;
            width: 133.03px;
            height: 130.41px;
            background-repeat: no-repeat;
            background-size: 100%;
        }
        .coupon-popover-title {
            color: var(----G9, #282C33);
            font-size: 16px;
            font-weight: 500;
            line-height: 22px; /* 137.5% */
        }
        .coupon-popover-pay-btn {
            cursor: pointer;
            display: flex;
            padding: 4px 12px;
            align-items: center;
            gap: 4px;
            border-radius: var(--Radius-r4, 26px);
            border: 1px solid #FFFBF1;
            background: linear-gradient(92deg, #FCE8AF 0%, #FDF5D6 51.23%, #F5CE86 100%);
            box-shadow: 0px 1px 4px 0px rgba(255, 255, 255, 0.60) inset;
            color: var(----active-W8, var(--Yellow-8, #D88F00));
            font-size: 14px;
            font-weight: 500;
            line-height: 20px; /* 142.857% */
        }
    }
    &-body {
        position: relative;
        top: -10px;
        border-radius: 10px;
        background: #FFF;
        padding: 16px 16px 0 16px;
        color: var(----G9, #282C33);
        font-family: "PingFang SC";
        font-size: 14px;
        line-height: 20px; /* 142.857% */
    }
    .coupon-popover-count {
        padding: 8px 0 2px 0px;
        display: flex;
        gap: 12px;
        flex-direction: column-reverse;
        align-items: center;
        .coupon-count {
            text-align: right;
            font-family: "Baidu Number Plus", "Baidu Number";
            font-size: 28px;
            font-style: normal;
            font-weight: 500;
            line-height: 22px; /* 68.75% */
        }
        .coupon-count-desc {
            color: var(---hover-G8, #545B66);
            text-align: center;
        }
    }
    .coupon-popover-count-uc-baidu{
        display: flex;
        justify-content: space-between;
        .coupon-count {
            text-align: right;
            font-family: "Baidu Number Plus", "Baidu Number";
            font-size: 16px;
            font-weight: 500;
            line-height: 22px; /* 137.5% */
        }
    }
    .coupon-popover-line {
        width: 100%;
        height: 1px;
        background: #E2E6F0;
        margin-top: 12px;
    }
    .coupon-popover-property {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    .property-item {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        line-height: 20px;
        &:last-child {
            padding-bottom: 10px;
        }
        &-right {
            line-height: 16px;
        }
        &-count {
            text-align: right;
            font-family: "Baidu Number Plus", "Baidu Number";
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 22px; /* 137.5% */
            margin-right: 2px;
        }
    }
}
</style>